/*
 * ------------------------------------------------------------
 * CLIENT CUSTOMIZATION — meba
 *
 * "Signature glint" quick-add enhancement. The round bag button and its
 * hover fill are pure CSS (assets/meba.css, .image-frame .quick-add__submit);
 * this script adds the decorative layers that CSS pseudo-elements can't cover
 * — three light streaks, a corner spark, a check and a burst — and, on a real
 * add-to-cart, morphs the bag into the check with a gold burst.
 *
 * The confirmation is driven by Dawn's cartUpdate pub/sub event, and only for
 * the two sources that actually add a product: 'product-form' (Dawn's own form)
 * and 'product-options' (products whose option set puts the product and its fee
 * lines in one request). So it only fires on a genuine add. The multi-variant
 * button opens the choose-options modal instead, so it never shows the check.
 *
 * Re-runs on load, on shopify:section:load (theme editor), and on collection
 * AJAX re-render (a MutationObserver on #ProductGridContainer), so the injected
 * layers survive facet filtering / pagination.
 * ------------------------------------------------------------
 */
(function () {
  'use strict';

  // `button` matters: a product with an option set renders its card control as
  // an <a> to the product page instead of an add-to-cart button, and glint
  // layers on a link would promise an add that never happens. Dawn renders every
  // real add / choose-options control as a <button>, so nothing is lost.
  var SELECTOR = '.image-frame button.quick-add__submit';
  var STAR =
    '<svg viewBox="0 0 48 48" fill="none"><g fill="#fff"><path d="M1 24 L24 22.4 L47 24 L24 25.6 Z"/><path d="M24 9 L25.5 24 L24 39 L22.5 24 Z"/></g><circle cx="24" cy="24" r="1.6" fill="#fff"/></svg>';
  var CHECK =
    '<svg viewBox="0 0 24 24" fill="none"><path d="M5 12.5l4.4 4.4L19 7.2" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function enhance(btn) {
    if (!btn || btn.dataset.mebaQa) return;
    btn.dataset.mebaQa = '1';
    var tpl = document.createElement('template');
    tpl.innerHTML =
      '<span class="burst" aria-hidden="true"></span>' +
      '<span class="streak gold" aria-hidden="true"></span>' +
      '<span class="streak white" aria-hidden="true"></span>' +
      '<span class="streak trail" aria-hidden="true"></span>' +
      '<span class="spark" aria-hidden="true">' + STAR + '</span>' +
      '<span class="check" aria-hidden="true">' + CHECK + '</span>';
    btn.appendChild(tpl.content);
  }

  function scan(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(enhance);
  }

  // Remember the last clicked direct-add button so we only confirm that one.
  // Multi-variant buttons open the options modal (not inside a <product-form>),
  // so they don't arm the confirmation.
  var pending = null;
  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target.closest ? event.target.closest(SELECTOR) : null;
      pending = btn && btn.closest('product-form') ? btn : null;
    },
    true
  );

  function confirmAdd(btn) {
    if (!btn) return;
    btn.classList.add('added');
    setTimeout(function () {
      btn.classList.remove('added');
    }, 1600);
  }

  function wireCartEvents() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      // Two sources add a product: Dawn's own product form, and product-options.js
      // for products whose option set means the fee lines go in the same request.
      if (pending && event && (event.source === 'product-form' || event.source === 'product-options')) {
        confirmAdd(pending);
        pending = null;
      }
    });
  }

  function init() {
    scan(document);
    wireCartEvents();
    var grid = document.getElementById('ProductGridContainer');
    if (grid && 'MutationObserver' in window) {
      new MutationObserver(function () {
        scan(grid);
      }).observe(grid, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
